module.exports = __webpack_public_path__ + "img/12.1449e68a.jpg";